const { connect } = require('react-redux');
const { context } = require('../app-context');
const ForceAppUpgradeDialog = require('components/ForceAppUpgradeDialog');

const { attemptAppUpgrade, continueAppUpgrade } = require('../initializers/connectivity');

const selectors = context.selectors.all;

module.exports = connect(
    (state) => ({
        isForceAppUpgradeMode: selectors.getIsForceAppUpgradeMode(state),
        apiAppVersion: selectors.getApiAppVersion(state),
        frontendAppVersion: selectors.getFrontendAppVersion(state)
    }),
    () => ({ onAttempt: attemptAppUpgrade, onContinue: continueAppUpgrade })
)(ForceAppUpgradeDialog);
